import {memo, useMemo} from 'react';
import {HouseholdItem} from '@/map/@types';
import {AreaAnalyticsFilter} from '@/map/enums';
import {HouseMarker} from './HouseMarker';

interface IProps {
  map: naver.maps.Map;
  items: any;
  hidden?: boolean;
}

export const HouseMarkerGroup = memo(({map, items, hidden}: IProps) => {
  const markers = useMemo<HouseholdItem[] | undefined>(() => {
    if (items) {
      const ret = items[AreaAnalyticsFilter.HOUSE]
        ? [...items[AreaAnalyticsFilter.HOUSE]]
        : [];

      if (items[AreaAnalyticsFilter.UPCOMMING_APTS]) {
        ret.push({
          type: AreaAnalyticsFilter.UPCOMMING_APTS,
          locationInfo: items[AreaAnalyticsFilter.UPCOMMING_APTS],
        });
      }

      return ret;
    }
  }, [items]);

  if (!items || !markers?.length) {
    return null;
  }

  return (
    <>
      {markers.map((building) =>
        building.locationInfo.map((i, idx) => (
          <HouseMarker
            key={idx}
            type={building.type}
            item={i}
            map={map}
            visible={!hidden}
          />
        ))
      )}
    </>
  );
});
